import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'releaseNoteFormat',
    standalone: false
})
export class ReleaseNoteFormatPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return '';
    }

    let text = '';
    let link: string | undefined;
    let linkText: string | undefined;

    if (typeof value === 'string') {
      text = value;
    } else if (typeof value === 'object') {
      text = value.text || '';
      link = value.link;
      linkText = value.linkText;

      // Replace the [link] placeholder with a clickable HTML link
      if (link && linkText && text.includes('[link]')) {
        text = text.replace(
          '[link]',
          `<a href="${link}" target="_blank">${linkText}</a>`
        );
      }
    }

    return text;
  }
}
